import { render, staticRenderFns } from "./UnderlineTabs.vue?vue&type=template&id=5a2ff294&scoped=true"
import script from "./UnderlineTabs.vue?vue&type=script&lang=js"
export * from "./UnderlineTabs.vue?vue&type=script&lang=js"
import style0 from "./UnderlineTabs.vue?vue&type=style&index=0&id=5a2ff294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2ff294",
  null
  
)

export default component.exports